module.exports = __webpack_public_path__ + "img/clock.87b30939.svg";